export { default } from './SearchResultItemContent';



// WEBPACK FOOTER //
// ./app/components/search/SearchResultItemContent/index.js